import * as config from '../config';

export function getAssetUrl(url: string) {
  if (!url) return '';
  return `https://${config.S3_BUCKET_NAME}.s3-us-west-2.amazonaws.com/${url}`;
}
